module.exports = __webpack_public_path__ + "img/img9.b7c1aab8.svg";